/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const BlurIcon = ({ width = 24, height = 24, hidden = false, title = 'Blur' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    viewBox="0 0 20 20"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="m10,18.75c-3.84766,0-6.75-2.70312-6.75-6.28809,0-2.73633,2.31934-5.78418,4.36523-8.47363.6543-.85938,1.27246-1.6709,1.76074-2.4043.27734-.41797.9707-.41797,1.24805,0,.48828.7334,1.10645,1.54492,1.76074,2.4043,2.0459,2.68945,4.36523,5.7373,4.36523,8.47363,0,3.58496-2.90234,6.28809-6.75,6.28809Zm0-15.44141c-.36914.50879-.77246,1.03906-1.19043,1.58789-1.90332,2.50098-4.05957,5.33496-4.05957,7.56543,0,2.77441,2.20801,4.78809,5.25,4.78809s5.25-2.01367,5.25-4.78809c0-2.23047-2.15625-5.06445-4.05957-7.56543-.41797-.54883-.82129-1.0791-1.19043-1.58789Z"
      fill="currentColor"
    />
  </svg>`;
};
